import React, { ReactNode } from 'react';

import css from './index.module.css';

interface IProps {
  icon: ReactNode;
  title: ReactNode;
  description: string;
}

const ExperienceInfo: React.FC<IProps> = ({ icon, title, description }) => {
  return (
    <div className={css.wrapper}>
      <div className={css.icon}>{icon}</div>
      <div className={css.title}>{title}</div>
      <div className={css.description}>{description}</div>
    </div>
  );
};

export default ExperienceInfo;
